import { cva } from '@/styled-system/css';

export const popoverContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'obj.default',
    flexDirection: 'column',
    backgroundColor: 'bg.elevated.mediumShadow',
    filter: 'drop-shadow({shadows.Popover.Content})',
    maxWidth: '360px',
    maxHeight: '320px',
    position: 'relative',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
    modal: {
      true: {
        blockSize: 'auto',
      },
      false: {},
    },
  },
});

export const popoverContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'popover',
      },
    },
    dividers: {
      true: {},
      false: {},
    },
    tone: {
      neutral: {},
      critical: {},
      info: {},
      success: {},
      warning: {},
    },
  },
  compoundVariants: [
    {
      dividers: true,
      tone: 'critical',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.critical',
        },
      },
    },
    {
      dividers: true,
      tone: 'info',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.info',
        },
      },
    },
    {
      dividers: true,
      tone: 'success',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.success',
        },
      },
    },
    {
      dividers: true,
      tone: 'warning',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.warning',
        },
      },
    },
  ],
});
